<template>
  <div>
    <h1 class="text-center text-base text-3-3/4 text-wine font-site">{{ title }}</h1>
    <h2 v-if="subtitle" class="text-center text-base text-2xl text-wine-light">
      {{ subtitle }}
    </h2>
    <h3 v-if="variety" class="text-center text-base text-xl text-black">
      {{ varieties(variety) }}
    </h3>
    <template v-if="subtitles">
      <template v-for="(item, index) in subtitles">
        <h2 :key="index + 'h2'" class="text-center text-base text-2xl text-wine-light">
          {{ item.subtitle }}
        </h2>
        <h3 :key="index + 'h3'" class="text-center text-base text-xl text-black">
          {{ varieties(item.variety) }}
        </h3>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitles: {
      type: Array,
      default: () => {},
    },
    varitey: {
      type: String,
      default: '',
    },
  },
  methods: {
    varieties(variety) {
      if (!variety) return ''
      if (!Array.isArray(variety)) {
        return `Rebsorte: ${variety}`
      } else {
        return `Rebsorten: ${variety.slice(0, variety.length - 1).join(', ') + ' & ' + variety[variety.length - 1]}`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.text-3-3\/4 {
  font-size: 3.75rem;
}
</style>
